import type { LegalLink } from '../types/content'

export const siteConfig = {
  brandName: 'Tricotin con Amore',
  price: '19 €',

  pageTitle: 'Tricotin con Amore | Guide e cartamodelli',
  pageDescription:
    'Scopri il pack digitale Tricotin con Amore: una guida pratica, cartamodelli e quattro bonus per creare decorazioni e piccoli regali personalizzati.',

  /**
   * URL di pagamento autorizzato. Usato SOLO dal pulsante della sezione #acquista.
   * Importo e valuta del checkout per l’Italia da verificare prima del lancio.
   */
  checkoutUrl: 'https://tricotin-con-amore.impultienda.ar/checkout/tricotin-con-amore',

  /**
   * Video di presentazione (contenitore verticale 4:5).
   * Vuoto o non riproducibile = viene mostrata la copertina della guida principale.
   */
  heroVideoUrl: 'https://cdn.magicpatterns.com/uploads/1YtCZjecgWzyU9EtFcrDku/IMG_8081.mov',

  /**
   * Meta Pixel autorizzato per Tricotin con Amore. Vuoto = non caricato.
   * Meccanismo di consenso ai cookie: da definire prima della pubblicazione.
   */
  metaPixelId: '1854538235550899',

  /** Testo del bollino circolare sul video (numero da verificare prima della pubblicazione). */
  heroBadge: { value: 'Oltre 300', label: 'cartamodelli' },

  /**
   * Capsula di valutazione dell’hero. Dati DA CONFERMARE:
   * finché confirmed è false, viene mostrata solo nella vista di lavoro.
   */
  trust: {
    rating: 4.9,
    customerLabel: 'Oltre 1.500 donne stanno già creando',
    confirmed: false,
  },

  /** Risposte FAQ in attesa di condizioni confermate. Vuoto = domanda nascosta. */
  deliveryAnswer: '',
  commercialUseAnswer: '',
  refundAnswer: '',

  /** Link del footer. Vengono mostrati solo quelli con un URL reale. */
  legalLinks: [
    { label: 'Contatti', href: '' },
    { label: 'Termini e condizioni di vendita', href: '' },
    { label: 'Informativa sulla privacy', href: '' },
    { label: 'Contenuti digitali e diritto di recesso', href: '' },
  ] as LegalLink[],
}
